<transition name="modal">
  <div class="modal-mask task-modal-mask calculated-picker-modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <app-sub-navigation-bar
          back-label="Back to task"
          @back="$emit('close')"
        />

        <div class="task-modal-shell">
          <div class="task-modal-body">
            <h4 class="task-modal-title">{{ title }}</h4>

            <form class="ui form task-modal-picker-filters" v-on:submit.prevent>
              <div class="field">
                <app-field-label>Type</app-field-label>
                <app-select
                  :defaultLabel="'All products'"
                  :items="typeSelectItems"
                  :value="''"
                  @selected="filterByType($event.id)"
                />
              </div>
              <div class="field">
                <app-field-label>Search</app-field-label>
                <app-text-input
                  icon="search"
                  placeholder="Search product name"
                  v-model="search"
                  v-on:keyup="filterByDescription(search)"
                />
              </div>
            </form>

            <div class="task-modal-picker-list-header task-modal-picker-list-header--with-qty">
              <span></span>
              <span class="task-modal-picker-list-header__label">Description</span>
              <span class="task-modal-picker-list-header__qty">Qty</span>
            </div>

            <div
              v-for="option in computedOptions"
              :key="option.id || option.description"
              class="task-modal-picker-row task-modal-picker-row--with-qty"
            >
              <div class="task-modal-picker-row__image">
                <img v-if="option.images !== null" :src="getImageUrl(option)" :alt="option.description || ''">
                <img v-else src="../../../../assets/img/no-image-available.jpg" alt="">
              </div>
              <div class="task-modal-picker-row__label">{{ displayCatalogName(option.description) }}</div>
              <div class="task-modal-picker-row__qty">
                <app-quantity-stepper
                  :model-value="option.qty"
                  @update:model-value="setOptionQty(option, $event)"
                />
              </div>
            </div>

            <app-loader v-if="loading === true"></app-loader>
          </div>
        </div>

        <app-sticky-form-footer>
          <a href="#" class="ui basic button smardie-btn-secondary" v-on:click.prevent="$emit('close')">Cancel</a>
          <a href="#" class="ui primary button" v-on:click.prevent="save">OK</a>
        </app-sticky-form-footer>
      </div>
    </div>
  </div>
</transition>
